import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { IonicModule } from "@ionic/angular";
import { TranslatePipe } from "@ngx-translate/core";
import { DayPipe } from "src/app/pipe/day";
import { SafeHtmlPipe } from "src/app/pipe/safehtmlpipe";

@Component({
  selector: "app-purchase-detail-card",
  templateUrl: "./purchase-detail-card.component.html",
  styleUrls: ["./purchase-detail-card.component.scss"],
  standalone: true,
  imports: [IonicModule, CommonModule, TranslatePipe, DayPipe, SafeHtmlPipe],
})
export class PurchaseDetailCardComponent {
  @Input() purchaseDetail: any;
  @Input() checkoutDescription: string = "";
  @Input() customOfferCashbackText: string = "";
  @Input() selectedLanguage: string = "en";
  @Input() displayMode: "payment" | "summary" = "payment";

  @Input() selectedDiscountValue: number = 0;
  @Input() updatedPrizeValue: number = 0;
  @Input() currencySymbol: string = "";
  @Input() preferredCurrency: string = "GBP";
  @Input() upsellSummaryArray: any[] = [];

  formatPrice(priceObj: any) {
    if (!priceObj) return "";
    if (typeof priceObj === "object") {
      return `${this.currencySymbol}${priceObj[this.preferredCurrency] ?? priceObj['GBP'] ?? ''}`;
    }
    return `${this.currencySymbol}${priceObj}`;
  }
}
